import { z } from 'zod'
import { docId, isoTimestamp } from './common.js'

/**
 * `csiuImports` — REQUIREMENTS.md §5.6. Unused until Phase 4.
 *
 * One document per import event, for audit and for the dashboard's per-code
 * "last reconciled" freshness indicator.
 */
export const csiuImportSchema = z.object({
  id: docId.optional(),
  userId: z.string().min(1),
  importedAt: isoTimestamp,

  filenames: z.array(z.string()).default([]),
  rowsImported: z.number().int().min(0).default(0),
  rowsSkipped: z.number().int().min(0).default(0),
  rowsFlagged: z.number().int().min(0).default(0),
  /** Budget code IDs touched — drives per-code freshness on the dashboard. */
  budgetCodesTouched: z.array(docId).default([]),
})

export type CsiuImport = z.infer<typeof csiuImportSchema>

/**
 * Rows whose JournalNumber matches this are already captured via the P-Card
 * flow and must be skipped (§6.4 step 2). This rule is why a `source: pcard`
 * transaction can never be confirmed by CSIU.
 */
export const CSIU_PCARD_SKIP_PATTERN = /p[\s-]?card/i

/** Days after which a code's CSIU data is considered stale (§7.4 step 5). */
export const CSIU_STALENESS_WARNING_DAYS = 45
